/**
 * BuyerJourneyContextContract (AJIP-16.02.007 · WS9)
 * Validation of buyer-specific context. Forbidden-keys sweep.
 */
import { InvalidBuyerContextError } from './BuyerJourneyErrors';

const MAX_BUYER_CONTEXT_BYTES = 8 * 1024;
const FORBIDDEN_KEYS = Object.freeze([
  'password', 'token', 'apikey', 'secret', 'credential',
  'cardnumber', 'cvv', 'privatekey', 'sessionid',
  'accesstoken', 'refreshtoken', 'bearer', 'authorization',
  'providersession', 'paymentinfo',
]);

const isPlainObject = (v) => (
  v !== null && typeof v === 'object' && !Array.isArray(v)
  && (Object.getPrototypeOf(v) === Object.prototype || Object.getPrototypeOf(v) === null)
);

const walkForbidden = (value, path = 'context') => {
  if (value === null || value === undefined) return;
  if (typeof value === 'function') {
    throw new InvalidBuyerContextError(`Executable data at ${path} prohibited`);
  }
  if (Array.isArray(value)) {
    value.forEach((item, i) => walkForbidden(item, `${path}[${i}]`));
    return;
  }
  if (typeof value !== 'object') return;
  if (!isPlainObject(value)) {
    throw new InvalidBuyerContextError(`${path} must be plain object`);
  }
  for (const [k, v] of Object.entries(value)) {
    if (FORBIDDEN_KEYS.includes(k.toLowerCase())) {
      throw new InvalidBuyerContextError(`Forbidden key '${k}' at ${path}`);
    }
    walkForbidden(v, `${path}.${k}`);
  }
};

const validateBuyerContext = (ctx) => {
  if (ctx === null || ctx === undefined) return true;
  if (!isPlainObject(ctx)) throw new InvalidBuyerContextError('Context must be plain object');
  walkForbidden(ctx);
  let s; try { s = JSON.stringify(ctx); } catch (_) { throw new InvalidBuyerContextError('Not serialisable'); }
  const bytes = typeof Buffer !== 'undefined' ? Buffer.byteLength(s, 'utf8') : s.length;
  if (bytes > MAX_BUYER_CONTEXT_BYTES) throw new InvalidBuyerContextError('Context exceeds byte cap');
  return true;
};

export { validateBuyerContext, MAX_BUYER_CONTEXT_BYTES, FORBIDDEN_KEYS };
